
      const customCSSPropertiesMap = {
        "maxContentWidth": "--awsui-max-content-width-rhu47t",
"minContentWidth": "--awsui-min-content-width-rhu47t",
"breadcrumbsGap": "--awsui-breadcrumbs-gap-rhu47t",
"contentGapLeft": "--awsui-content-gap-left-rhu47t",
"contentGapRight": "--awsui-content-gap-right-rhu47t",
"contentHeight": "--awsui-content-height-rhu47t",
"contentLayoutDefaultHorizontalPadding": "--awsui-content-layout-default-horizontal-padding-rhu47t",
"contentLayoutMaxContentWidth": "--awsui-content-layout-max-content-width-rhu47t",
"contentLayoutMainGap": "--awsui-content-layout-main-gap-rhu47t",
"defaultMaxContentWidth": "--awsui-default-max-content-width-rhu47t",
"defaultMinContentWidth": "--awsui-default-min-content-width-rhu47t",
"drawerSize": "--awsui-drawer-size-rhu47t",
"drawerMinSize": "--awsui-drawer-min-size-rhu47t",
"bottomDrawerSize": "--awsui-bottom-drawer-size-rhu47t",
"footerHeight": "--awsui-footer-height-rhu47t",
"headerGap": "--awsui-header-gap-rhu47t",
"headerHeight": "--awsui-header-height-rhu47t",
"layoutWidth": "--awsui-layout-width-rhu47t",
"mainGap": "--awsui-main-gap-rhu47t",
"mainOffsetLeft": "--awsui-main-offset-left-rhu47t",
"mainTemplateRows": "--awsui-main-template-rows-rhu47t",
"mobileBarHeight": "--awsui-mobile-bar-height-rhu47t",
"notificationsHeight": "--awsui-notifications-height-rhu47t",
"offsetTop": "--awsui-offset-top-rhu47t",
"overlapHeight": "--awsui-overlap-height-rhu47t",
"navigationWidth": "--awsui-navigation-width-rhu47t",
"splitPanelReportedHeaderSize": "--awsui-split-panel-reported-header-size-rhu47t",
"splitPanelReportedSize": "--awsui-split-panel-reported-size-rhu47t",
"splitPanelHeight": "--awsui-split-panel-height-rhu47t",
"splitPanelMinWidth": "--awsui-split-panel-min-width-rhu47t",
"splitPanelMaxWidth": "--awsui-split-panel-max-width-rhu47t",
"toolsMaxWidth": "--awsui-tools-max-width-rhu47t",
"toolsWidth": "--awsui-tools-width-rhu47t",
"toolsAnimationStartingOpacity": "--awsui-tools-animation-starting-opacity-rhu47t",
"contentScrollMargin": "--awsui-content-scroll-margin-rhu47t",
"flashbarStackDepth": "--awsui-flashbar-stack-depth-rhu47t",
"flashbarStackIndex": "--awsui-flashbar-stack-index-rhu47t",
"flashbarStickyBottomMargin": "--awsui-flashbar-sticky-bottom-margin-rhu47t",
"stackedNotificationsBottomMargin": "--awsui-stacked-notifications-bottom-margin-rhu47t",
"stackedNotificationsDefaultBottomMargin": "--awsui-stacked-notifications-default-bottom-margin-rhu47t",
"dropdownDefaultMaxWidth": "--awsui-dropdown-default-max-width-rhu47t",
"spinnerRotatorFrom": "--awsui-spinner-rotator-from-rhu47t",
"spinnerRotatorTo": "--awsui-spinner-rotator-to-rhu47t",
"spinnerLineLeftFrom": "--awsui-spinner-line-left-from-rhu47t",
"spinnerLineLeftTo": "--awsui-spinner-line-left-to-rhu47t",
"spinnerLineRightFrom": "--awsui-spinner-line-right-from-rhu47t",
"spinnerLineRightTo": "--awsui-spinner-line-right-to-rhu47t",
"sliderLabelCount": "--awsui-slider-label-count-rhu47t",
"sliderTickCount": "--awsui-slider-tick-count-rhu47t",
"sliderReferenceColumn": "--awsui-slider-reference-column-rhu47t",
"sliderNextReferenceColumn": "--awsui-slider-next-reference-column-rhu47t",
"sliderMaxStart": "--awsui-slider-max-start-rhu47t",
"sliderMinEnd": "--awsui-slider-min-end-rhu47t",
"sliderRangeInlineSize": "--awsui-slider-range-inline-size-rhu47t",
"sliderTooltipPosition": "--awsui-slider-tooltip-position-rhu47t",
"togglesLeftWidth": "--awsui-toggles-left-width-rhu47t",
"togglesRightWidth": "--awsui-toggles-right-width-rhu47t",
"promptInputMaxRows": "--awsui-prompt-input-max-rows-rhu47t",
"promptInputScrollHeight": "--awsui-prompt-input-scroll-height-rhu47t",
"dragHandleAnimationInlineOffset": "--awsui-drag-handle-animation-inline-offset-rhu47t",
"dragHandleAnimationBlockOffset": "--awsui-drag-handle-animation-block-offset-rhu47t",
"styleBackgroundActive": "--awsui-style-background-active-rhu47t",
"styleBackgroundDefault": "--awsui-style-background-default-rhu47t",
"styleBackgroundDisabled": "--awsui-style-background-disabled-rhu47t",
"styleBackgroundHover": "--awsui-style-background-hover-rhu47t",
"styleBorderColorActive": "--awsui-style-border-color-active-rhu47t",
"styleBorderColorDefault": "--awsui-style-border-color-default-rhu47t",
"styleBorderColorDisabled": "--awsui-style-border-color-disabled-rhu47t",
"styleBorderColorHover": "--awsui-style-border-color-hover-rhu47t",
"styleColorActive": "--awsui-style-color-active-rhu47t",
"styleColorDefault": "--awsui-style-color-default-rhu47t",
"styleColorDisabled": "--awsui-style-color-disabled-rhu47t",
"styleColorHover": "--awsui-style-color-hover-rhu47t",
"styleFocusRingBorderColor": "--awsui-style-focus-ring-border-color-rhu47t",
"styleFocusRingBorderRadius": "--awsui-style-focus-ring-border-radius-rhu47t",
"styleFocusRingBorderWidth": "--awsui-style-focus-ring-border-width-rhu47t",
"styleFocusRingBoxShadow": "--awsui-style-focus-ring-box-shadow-rhu47t",
"styleBoxShadowActive": "--awsui-style-box-shadow-active-rhu47t",
"styleBoxShadowDefault": "--awsui-style-box-shadow-default-rhu47t",
"styleBoxShadowDisabled": "--awsui-style-box-shadow-disabled-rhu47t",
"styleBoxShadowHover": "--awsui-style-box-shadow-hover-rhu47t",
"styleBackgroundReadonly": "--awsui-style-background-readonly-rhu47t",
"styleBorderColorReadonly": "--awsui-style-border-color-readonly-rhu47t",
"styleBoxShadowReadonly": "--awsui-style-box-shadow-readonly-rhu47t",
"styleColorReadonly": "--awsui-style-color-readonly-rhu47t",
"styleBackgroundFocus": "--awsui-style-background-focus-rhu47t",
"styleBorderColorFocus": "--awsui-style-border-color-focus-rhu47t",
"styleBoxShadowFocus": "--awsui-style-box-shadow-focus-rhu47t",
"styleColorFocus": "--awsui-style-color-focus-rhu47t",
"stylePlaceholderColor": "--awsui-style-placeholder-color-rhu47t",
"stylePlaceholderFontSize": "--awsui-style-placeholder-font-size-rhu47t",
"stylePlaceholderFontStyle": "--awsui-style-placeholder-font-style-rhu47t",
"stylePlaceholderFontWeight": "--awsui-style-placeholder-font-weight-rhu47t",
"styleTabsActiveIndicatorColor": "--awsui-style-tabs-active-indicator-color-rhu47t",
"styleTabsActiveIndicatorWidth": "--awsui-style-tabs-active-indicator-width-rhu47t",
"styleTabsActiveIndicatorBorderRadius": "--awsui-style-tabs-active-indicator-border-radius-rhu47t",
"styleTabsSeparatorColor": "--awsui-style-tabs-separator-color-rhu47t",
"styleTabsSeparatorWidth": "--awsui-style-tabs-separator-width-rhu47t",
"alertFocusRingBorderColor": "--awsui-alert-focus-ring-border-color-rhu47t",
"alertFocusRingBorderRadius": "--awsui-alert-focus-ring-border-radius-rhu47t",
"alertFocusRingBorderWidth": "--awsui-alert-focus-ring-border-width-rhu47t",
"alertFocusRingBoxShadow": "--awsui-alert-focus-ring-box-shadow-rhu47t",
"alertIconColor": "--awsui-alert-icon-color-rhu47t",
"promptInputStyleBackgroundDefault": "--awsui-prompt-input-style-background-default-rhu47t",
"promptInputStyleBackgroundDisabled": "--awsui-prompt-input-style-background-disabled-rhu47t",
"promptInputStyleBackgroundFocus": "--awsui-prompt-input-style-background-focus-rhu47t",
"promptInputStyleBackgroundHover": "--awsui-prompt-input-style-background-hover-rhu47t",
"promptInputStyleBackgroundReadonly": "--awsui-prompt-input-style-background-readonly-rhu47t",
"promptInputStyleBorderColorDefault": "--awsui-prompt-input-style-border-color-default-rhu47t",
"promptInputStyleBorderColorDisabled": "--awsui-prompt-input-style-border-color-disabled-rhu47t",
"promptInputStyleBorderColorFocus": "--awsui-prompt-input-style-border-color-focus-rhu47t",
"promptInputStyleBorderColorHover": "--awsui-prompt-input-style-border-color-hover-rhu47t",
"promptInputStyleBorderColorReadonly": "--awsui-prompt-input-style-border-color-readonly-rhu47t",
"promptInputStyleBoxShadowDefault": "--awsui-prompt-input-style-box-shadow-default-rhu47t",
"promptInputStyleBoxShadowDisabled": "--awsui-prompt-input-style-box-shadow-disabled-rhu47t",
"promptInputStyleBoxShadowFocus": "--awsui-prompt-input-style-box-shadow-focus-rhu47t",
"promptInputStyleBoxShadowHover": "--awsui-prompt-input-style-box-shadow-hover-rhu47t",
"promptInputStyleBoxShadowReadonly": "--awsui-prompt-input-style-box-shadow-readonly-rhu47t",
"promptInputStyleColorDefault": "--awsui-prompt-input-style-color-default-rhu47t",
"promptInputStyleColorDisabled": "--awsui-prompt-input-style-color-disabled-rhu47t",
"promptInputStyleColorFocus": "--awsui-prompt-input-style-color-focus-rhu47t",
"promptInputStyleColorHover": "--awsui-prompt-input-style-color-hover-rhu47t",
"promptInputStyleColorReadonly": "--awsui-prompt-input-style-color-readonly-rhu47t",
"promptInputStylePlaceholderColor": "--awsui-prompt-input-style-placeholder-color-rhu47t",
"promptInputStylePlaceholderFontSize": "--awsui-prompt-input-style-placeholder-font-size-rhu47t",
"promptInputStylePlaceholderFontStyle": "--awsui-prompt-input-style-placeholder-font-style-rhu47t",
"promptInputStylePlaceholderFontWeight": "--awsui-prompt-input-style-placeholder-font-weight-rhu47t",
"progressBarBackgroundColor": "--awsui-progress-bar-background-color-rhu47t",
"progressBarBorderRadius": "--awsui-progress-bar-border-radius-rhu47t",
"progressBarHeight": "--awsui-progress-bar-height-rhu47t",
"progressValueBackgroundColor": "--awsui-progress-value-background-color-rhu47t",
      };
      export default customCSSPropertiesMap;
    